module.exports = __webpack_public_path__ + "static/media/psm1.7170fd3c.svg";